export { isDigitChar, isLetterChar, isSpecialChar, KeyPress, KeyCode } from './key-press';

